export const FETCH_CREATE_INVITATION = 'FETCH_CREATE_INVITATION';
export const FETCH_UPDATE_INVITATION = 'FETCH_UPDATE_INVITATION';
export const FETCH_DELETE_INVITATION = 'FETCH_DELETE_INVITATION';
export const FETCH_GET_ALL_INVITATIONS = 'FETCH_GET_ALL_INVITATIONS';
export const FETCH_GET_ALL_INVITATIONS_SENT = 'FETCH_GET_ALL_INVITATIONS_SENT';
export const FETCH_CREATE_ACCEPT_INVITATION = 'FETCH_CREATE_ACCEPT_INVITATION';
export const FETCH_CREATE_REJECT_INVITATION = 'FETCH_CREATE_REJECT_INVITATION';
